export default "/app/themes/majeures/build/images/avatar1.svg?e4d5c4d0e6f0f2109d8475abf83703ff";